import { useState } from 'react';

// Stub - Moralis 1inch plugin removed. Implement with direct 1inch API if needed.
const useInchDex = (chain) => {
  const [tokenList, setTokenlist] = useState({});

  const getQuote = async (params) => {
    console.warn('1inch integration removed - implement with direct API');
    return null;
  };

  const trySwap = async (params) => {
    console.warn('1inch integration removed - implement with direct API');
    return null;
  };

  const doSwap = async (params) => {
    console.warn('1inch integration removed - implement with direct API');
    return null;
  };

  return { getQuote, trySwap, doSwap, tokenList };
};

export default useInchDex;
